var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-multiselect',{attrs:{"options":_vm.options,"current-options":_vm.currentOptions.map(function (role) { return role.value; })},on:{"change":function($event){return _vm.updateCurrentRoles($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }